var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaltel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#009FD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.841 5.593a10.471 10.471 0 0 1 1.79 5.877c0 3.046-1.293 5.791-3.36 7.714a8.83 8.83 0 0 0 1.68-5.187c0-4.882-3.945-8.839-8.82-8.839-4.55 0-8.292 3.453-8.764 7.888a10.6 10.6 0 0 0-.048.84c0 .037-.004.074-.004.11 0 3.398 1.57 6.426 4.016 8.405a10.483 10.483 0 0 1-1.79-5.88A10.5 10.5 0 0 1 8.9 8.809a8.805 8.805 0 0 0-1.68 5.188c0 4.881 3.95 8.838 8.82 8.838s8.816-3.957 8.816-8.838h.004c0-3.397-1.57-6.422-4.016-8.4",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaltel);
export default __webpack_public_path__ + "static/media/paltel.0d6d0a0f918a1faf0703912fcdf34b80.svg";
export { ForwardRef as ReactComponent };